import { Container, Title } from './CardInformation.StyledComponents';
import { CardInformationProps } from './CardInformation.types';

export const CardInformation = ({ children, title, subTitle }: CardInformationProps) => {
    return (
        <Container data-testid={title?.toLowerCase().replace(' ', '-')}>
            {title && <Title>{title}</Title>}
            {subTitle}
            {children}
        </Container>
    );
};
